import _ from "lodash";
import PropTypes from "prop-types";
import React, { useState, useContext } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { Button } from "../Button";

const descriptionStyles = createUseStyles({
  description: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    color: jssVariables.colors.text.dark,
    paddingTop: jssVariables.normal_gap,
    ..._.get(props, "customStyles.description", {}),
  }),
  descShort: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.descShort", {}),
  }),
  descTxt: (props) => ({
    display: "grid",
    fontSize: "large",
    maxHeight: props.descVisible ? "100%" : "6rem",
    overflow: "hidden",
    transition: ".5s",
    ..._.get(props, "customStyles.descTxt", {}),
  }),
  descBtn: (props) => ({
    padding: 0,
    ..._.get(props, "customStyles.descBtn", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    description: (props) => ({
      ..._.get(props, "customStyles.description.smallscreen", {}),
    }),
    descTxt: (props) => ({
      gridTemplateRows: props.descVisible
        ? "max-content"
        : "minmax(auto, 10vh)",
      ..._.get(props, "customStyles.descTxt.smallscreen", {}),
    }),
  },
});
const Description = () => {
  const [descVisible, setDescVisible] = useState(false);
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "activityDetailsDescription",
  });

  const classes = descriptionStyles({
    type,
    descVisible,
    customStyles,
  });

  const { t } = useContext(TranslationContext);

  const { loading, activity } = useSelector((state) => {
    return {
      loading: _.get(state.ActivitySelected, "loading", true),
      activity: _.get(state.ActivitySelected, "activity", []),
    };
  });

  var description = _.get(activity, "description", "");
  var about = _.get(activity, "about", "");

  return loading ? null : (
    <div className={classes.description}>
      {description && <span className={classes.descShort}>{description}</span>}
      <div
        className={classes.descTxt}
        dangerouslySetInnerHTML={{ __html: about }}></div>
      {type !== "type2" && (
        <React.Fragment>
          <Button
            id={descVisible ? "viewLess" : "viewMore"}
            text={descVisible ? t("viewLess") : t("viewMore")}
            size="small"
            bold={true}
            onClick={() => setDescVisible(!descVisible)}
            customStyles={{
              ButtonDefault: {
                ..._.get(customStyles, "btnStyles", {}),
              },
            }}
          />
        </React.Fragment>
      )}
      {type === "type2" && (
        <Button
          text={descVisible ? t("less") : t("more")}
          size="small"
          bold={true}
          onClick={() => setDescVisible(!descVisible)}
        />
      )}
    </div>
  );
};
Description.defaultProps = {
  details: {},
};
Description.propTypes = {
  details: PropTypes.object.isRequired,
};
export default Description;
